import { FileTextThin, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  fileName: string
  error: string
  onClear: () => void
}

export const DroppedFile: React.FC<Props> = ({ fileName, error, onClear }) => {
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onClear()
  }

  return (
    <div className={clsJoin(css.file_state, Boolean(error) && css.error)}>
      <button
        type="button"
        className={css.remove_button}
        onClick={handleOnClick}
      >
        <Trash />
      </button>

      <FileTextThin className={css.file_icon} />
      <div className={css.file_name}>{fileName}</div>
    </div>
  )
}
